enum SchedulerDisplayMode {
    Classic,
    Stacked
}

enum PendingApprovalStatus {
    Pending = 0,
    Returned,
    Approved
}

enum CalendarSlotType {
    Appointment = 1,
    PredefinedAppointment = 2,
    RuleSet = 3,
    RuleSetSlot = 4,
    PredefinedGroup
}

enum Language {
    en,
    fr,
    es
}

enum RecallStatusTypes {
    Completed = 1,
    Due = 2,
    PastDue = 3
}

enum TreeNodeTarget {
    Unassigned,
    Myle_Documents_DocumentTree_ClassSelection,
    Myle_Documents_DocumentTree_SubClassSelection
}

enum DocumentUIState {
    Search,
    View,
    Edit,
    Create,
    InboundFaxInboxMailbox,
    InboundFaxTrashMailbox,
    InboundFaxIndexedMailbox,
    Annotate,
    Extension
}

enum CommunicationsUIState {
    MessagesSearch = 1,
    MessagesView,
    MessagesCreate,
    RecallsSearch,
    RecallsCreate,
    RecallsView,
    TasksSearch,
    TasksView,
    TasksCreate,
    ExternalCommunicationInbox,
    ExternalCommunicationCreate,
    ExternalCommunicationOutbox,
    ExternalCommunicationView,
    PortalCommunicationInbox,
    PortalCommunicationView,
    PortalCommunicationCreate
}

enum CommunicationsUIStateInbox {
    Inbox = 1,
    Drafts,
    Archive,
    Trash,
    Sent,
    FlaggedForReview
}

enum InboundFaxesUIStateInbox {
    Inbox = 1,
    Trash,
    Indexed
}

enum MessageOrTaskContext {
    Unspecified,
    Communications,
    Documents,
    Labs,
    Encounter,
    PopulationBasedFunding
}

enum CommunicationStateType {
    Tab,
    MessageSearch,
    MessageSettingContainer,
    TaskSearch,
    TaskSettingContainer,
    MessageTaskView,
    MessageTaskEdit,
    RecallSearch,
    RecallSettingContainer,
    RecallEdit,
    RecallView
}

enum MessageOrTaskEditContext {
    Reply,
    ReplyAll,
    Forward
}

enum PAListSortOrderType {
    AppointmentTime = 1,
    Patient,
    Status
}

enum DocumentSortOrderType {
    DocumentDate = 1,
    AttachedOnDate,
    Doctor,
    Description,
    Type,
    Status,
    PortalStatus,
    Site
}

enum PortfolioNotesSortOrderType {
    Date = 1,
    Status,
    Reason,
    Notes,
    Patient,
    NAM,
    ConsultationDate
}

enum LabRequestType {
    Request = 0,
    RIS,
    LIS
}

enum PortfolioConsultationRequestsSortOrderType {
    CreationDate = 1,
    Patient,
    DueDate,
    Speciality,
    RequestingStaff,
    Status,
    ConsultationDate
}

enum PortfolioExamRequestSortOrderType {
    DueDate = 1,
    Patient,
    CreatedOn,
    Reason,
    RequestingStaff,
    Status
}

enum PortfolioSentFaxSortOrderType {
    SentDate = 1,
    ReceiveDate,
    ItemDate,
    Patient,
    ItemType,
    SentBy,
    Status,
    Recipient,
    Action
}

enum PortfolioSentFaxStatus {
    InProgress = 100,
    Sent = 101,
    Failed = 102,
    SendingEmail = 103,
    NoAnswer = 104,
    Busy = 105,
    NoRemoteFax = 106,
    NotSent = 107
}

enum PortfolioPortalSyncHistoryOrderType {
    SyncDate = 1,
    ViewDate = 2,
    Status = 3
}

enum EnumPortalSyncStatus {
    unknown = 0,
    unsent = 1,
    pending = 2,
    viewed = 3,
    revoked = 4,
    error = 5
}

enum MyPreventiveActionsSortOrderType {
    DueDate = 1,
    Patient,
    Status
}

enum ClinicianFaxingPopupItemType {
    ConsultationRequest = 1,
    MedicalNote = 2
}

enum CommunicationRecallsSortOrderType {
    Patients = 1,
    ResponsibleProviders = 2,
    Description = 3,
    DueDate = 4,
    Priority = 5,
    Status = 6,
    State = 7
}

enum CommunicationMessagesSortOrderType {
    Subject = 1,
    From,
    To,
    Date,
    Priority,
    Patient
}

enum CommunicationTasksSortOrderType {
    Subject = 1,
    From,
    To,
    MessageDate,
    DueDate,
    Status,
    Priority,
    Patient
}

enum ExternalCommunicationsSortOrderType {
    Subject,
    From,
    To,
    ReceivedDate,
    Patient,
    SendStatus,
    SendDate
}

enum LabSortOrderType {
    ClinicianName = 1,
    Patient,
    SendingFacility,
    Context,
    MessageDate,
    RequestSubjects,
    Status,
    PortalStatus
}

enum InboundFaxSortOrderType {
    DateReceived,
    FaxNumber,
    Source,
    Class,
    PendingPagesCount,
    DeletedPagesCount,
    Action,
    Triage
}

enum InboundFaxImportanceType {
    Urgent,
    NotUrgent
}

enum LabInboxes {
    All,
    New,
    Suspended,
    Classified,
    ManualResults
}

enum LabActionInboxes {
    All,
    Nurses,
    Secretaries,
    Completed
}

enum LabActionInboxSortOrderType {
    ActionAge,
    Patient,
    Prescriber,
    ActionBy
}

enum LabTabViews {
    Inbox,
    Lab,
    Graph,
    ActionsInbox
}

enum AdminTabViews {
    Sites,
    ServiceCombos,
    BillableServices,
    Groups,
    Users,
    Log,
    Questionnaires,
    ExternalConsultationHistory,
    Roles
}

enum SchedulingTabViews {
    OpenSchedule,
    MainTemplate,
    CreateTemplate
}

enum PortfolioInboxes {
    Extension = 0,
    Notes,
    ConsultationRequests,
    Requests,
    Faxes,
    PendingApprovals,
    APSS_Recent,
    APSS_Purges,
    FailedFaxes,
    PortalPendingItems,
    PortalSyncItems,
    PreventiveActivities,
    PortalSyncItemsErrors,
    PopulationBasedFunding,
    APSS_ConseilNumerique,
    PreventiveRecallList
}

enum PreventiveRecallTab {
    Default = 1,
    CorrespondenceHistory
}

enum BillingInbox {
    Transactions = 1,
    Sales,
    Payable,
    BillingClaimStatus
}

enum SortDirection {
    ASC = 1,
    DESC
}

enum HandNotePageMode {
    New,
    Edit,
    EditBackgroundReset
}

enum RedirectTo {
    Patient,
    Labs,
    Calendar,
    List
}

enum ClinicalWaitingListsSortOrderType {
    DateAdded = 1,
    Priority,
    Patient,
    Comments
}

enum ClinicalWaitingListsUnclickableColumn {
    Patient
}

enum SitesUIState {
    Create = 1,
    View
}

enum InboundFaxMailboxType {
    Inbox,
    Trash,
    Indexed
}

enum PatientBillingHistoryOrderType {
    ClaimDate = 0,
    ProviderFullName
}

enum PopulationBasedFundingPortfolioSortOrder {
    Patient,
    Status,
    Proposal,
    ProposalDate,
    PatientDateOfBirth
}

enum PopulationBasedFundingEventAction {
    Register = 1,
    Deregister
}

enum PopulationBasedFundingEventDeregisteredReason {
    Deceased = 1,
    ServicesReceivedOutsidePrimaryCareOrganization,
    LeftArea,
    ChangePractitionerAssignment,
    AnotherReasonIndicatedInNotes
}

enum PopulationBasedFundingProposalReason {
    Unknown = 0,
    /// In the section immidiately below are HIBC's patient registration proposal codes.
    TwoConsecutiveServicesInPCOAndLivesInCatchmentArea = 1,
    AtLeastFiftyOnePercentReviewedServicesInPCOAndLivesInCatchementArea,
    RegisteredThroughPCOMSPRegisterSyncProcess,
    RegistrationEffectiveDateBackdated,
    /// In the section immidiately below are HIBC's patient de-registration proposal codes.
    PatientDeregisteredThroughPBFMSPSyncProcess = 101,
    MinistryRecordShowPatientDeceased,
    PatientNoLongerHasMSPCoverage,
    PatientMovedOutsidePracticeCatchmentAreaAndReceivedNoServices,
    PatientMovedOutsidePracticeCatchmentAreaAndReceivedAtLeastOneService = 105,
    PatientsLastThreeServicesWereReceivedOutsidePractice,
    LessThanFiftyOnePercentPatientsReviewedServicesInPractice,
    PatientReceivedMoreThanFiveServicesOutsidePractice,
    PatientRegisteredOnInitialPatientRegisterButNotPatientOfPractice,
    PatientHadBeenDeregisteredButCancellationDateBeingRevised = 110,
    PatientReceivedMoreThanTwoServicesOusideCatchmentArea,
    PatientLastTwoServicesOutsideCatchmentArea
}

enum PopulationBasedFundingEventOverrideReason {
    AnotherRegistrationReasonIndicatedInNotes = 1,
    CoveringVacationingPractitioner,
    PatientDeceased,
    PracticeFull,
    PatientExpressedIntentToSeeAnotherPractitioner,
    PatientMoved,
    PatientNotKnownToThePractice,
    PatientReferredToAnotherPractitioner,
    TemporaryReferralFromAnotherPractitioner,
    PatientVisitingCatchmentArea,
    SuspendMonthlyRegistrations,

    AnotherDeregistrationReasonIndicatedInNotes = 101,
    PatientSawAnotherPractitionerWhileUsualOnVacation,
    MinistryRecordsAreIncorrectAsPatientHasMSP,
    PatientLivesOutsideCatchmentAreaButIntentionToGetAllServices,
    PatientLivesOutsideCatchementAreaButRequiresSpecialCare,
    PatientTemporarilyReferredAnotherPractioner,
    MinistryAddressIncorrectAsPatientLivesInCatchmentArea,
    PatientOnVacation,
    PatientLivesOutsideCatchmentAreaButWorksOrAttendsSchoolThere,
    SuspendMonthlyDeregistrations
}

enum PopulationBasedFundingDeregistrationStatus {
    PatientDeregisteredThroughPBFMSPSyncProcess = 1,
    MinistryRecordShowPatientDeceased,
    PatientNoLongerHasMSPCoverage,
    PatientMovedOutsidePracticeCatchmentAreaAndReceivedNoServices,
    PatientMovedOutsidePracticeCatchmentAreaAndReceivedAtLeastOneService = 5,
    PatientsLastThreeServicesWereReceivedOutsidePractice,
    LessThanFiftyOnePercentPatientsReviewedServicesInPractice,
    PatientReceivedMoreThanFiveServicesOutsidePractice,
    PatientRegisteredOnInitialPatientRegisterButNotPatientOfPractice,
    PatientHadBeenDeregisteredButCancellationDateBeingRevised = 10,
    PatientReceivedMoreThanTwoServicesOusideCatchmentArea,
    PatientLastTwoServicesOutsideCatchmentArea
}

enum PopulationBasedFundingStatus {
    Registered,
    Deregistered,
    ProposedRegistration,
    ProposedDeregistration,
    InternalProposedRegistration,
    InternalProposedDeregistration
}

enum BatchEligibilityCheckStatusEnum {
    Registered = 1,
    NotRegistered,
    RegisteredToAnotherPbfPayee,
    PendingRegistration,
    PendingDeregistration,
    RegisteredToAnotherPbfPayeeWithinTheSameReportingGroup
}
enum PrivateBill_BilledTo {
    Patient = 1,
    ThirdParty
}

enum PayableInboxValidity {
    Valid = 0,
    Invalid = 1

}

enum PayableInboxSortOrderType {
    BillDate = 1
}

enum EmployeeSupervisor {
    Doctor = "Doctor",
    NursePractitioner = "Nurse Practitioner",
    Nurse = "Nurse",
    Professional = "Professional"
}

enum PrescriptionRenewalsOrderType {
    Patient,
    Source,
    ReceivedDate,
    AttachedOn,
    Status
}

enum PrescriptionRenewalsViewRenewMedicationTableOrderType {
    Medication,
    End,
    Dosage,
    Quantity,
    Refills,
    Duration,
    Status,
    Action
}

enum AdministrativeCode {
    Normal = 0,
    SpecialNeeds = 1
}

enum BillingClaimStatusType {
    AppointmentDate
}

enum ListModuleItemType {
    List
}

/**
 * How often a user needs to enter their PIN to sign documents.
 */
enum PinFrequency {
    Always,
    EverySession,
    EveryDay,
    Weekly,
    Monthly,
    Never
}

enum PinFrequencyDocumentType {
    ConsultationRequest,
    Document,
    ExamRequest,
    Form,
    Prescription,
    ObstetricalFile
}

enum AllowlistType {
    MedicalNoteAllowlist = 1,
    PatientFileAllowlist = 2
}

enum PharmacyOrdersSortOrderType {
    PreferredDate,
    ReceivedDate,
    LastUpdated
}

enum PharmacyOrderPreferredTimeOfDayType {
    Morning,
    Afternoon,
    Evening
}

enum PharmacyOrderDistributionType {
    PickUp,
    Delivery
}

/**
 * Specifies the status of a pharmacy order.
 */
enum PharmacyOrderStatus {
    /**
     * The customer has been contacted.
     */
    Contacted,

    /**
     * The customer has not been contacted.
     */
    NotContacted,

    /**
     * The order is to be prepared.
     */
    ToPrepare,

    /**
     * The order is on hold.
     */
    OnHold,

    /**
     * The order is completed.
     */
    Completed,

    /**
     * The order is canceled.
     */
    Canceled
}

/**
 * Specifies the status of a pharmacy order Medication.
 */
enum PharmacyOrderMedicationStatus {
    /**
     * The patient did not approve the medication.
     */
    OnHold,

    /**
     * The patient approved the medication.
     */
    Approved
}

enum FormMode {
    View,
    Edit,
    New
}

enum PortalCommunicationOrderType {
    Date,
    Subject,
    Patient,
    Priority
}

enum PortalCommunicationSentFilterSettingStatus {
    Unread,
    Read
}

export {
    AdministrativeCode,
    AdminTabViews,
    AllowlistType,
    BatchEligibilityCheckStatusEnum,
    BillingClaimStatusType,
    BillingInbox,
    CalendarSlotType,
    ClinicalWaitingListsSortOrderType,
    ClinicalWaitingListsUnclickableColumn,
    ClinicianFaxingPopupItemType,
    CommunicationMessagesSortOrderType,
    CommunicationRecallsSortOrderType,
    CommunicationStateType,
    CommunicationsUIState,
    CommunicationsUIStateInbox,
    CommunicationTasksSortOrderType,
    DocumentSortOrderType,
    DocumentUIState,
    EmployeeSupervisor,
    EnumPortalSyncStatus,
    ExternalCommunicationsSortOrderType,
    FormMode,
    HandNotePageMode,
    InboundFaxesUIStateInbox,
    InboundFaxImportanceType,
    InboundFaxMailboxType,
    InboundFaxSortOrderType,
    LabActionInboxes,
    LabActionInboxSortOrderType,
    LabInboxes,
    LabRequestType,
    LabSortOrderType,
    LabTabViews,
    Language,
    ListModuleItemType,
    MessageOrTaskContext,
    MessageOrTaskEditContext,
    MyPreventiveActionsSortOrderType,
    PAListSortOrderType,
    PatientBillingHistoryOrderType,
    PayableInboxSortOrderType,
    PayableInboxValidity,
    PendingApprovalStatus,
    PharmacyOrderDistributionType,
    PharmacyOrderMedicationStatus,
    PharmacyOrderPreferredTimeOfDayType,
    PharmacyOrdersSortOrderType,
    PharmacyOrderStatus,
    PinFrequency,
    PinFrequencyDocumentType,
    PopulationBasedFundingDeregistrationStatus,
    PopulationBasedFundingEventAction,
    PopulationBasedFundingEventDeregisteredReason,
    PopulationBasedFundingEventOverrideReason,
    PopulationBasedFundingPortfolioSortOrder,
    PopulationBasedFundingProposalReason,
    PopulationBasedFundingStatus,
    PortalCommunicationOrderType,
    PortalCommunicationSentFilterSettingStatus,
    PortfolioConsultationRequestsSortOrderType,
    PortfolioExamRequestSortOrderType,
    PortfolioInboxes,
    PortfolioNotesSortOrderType,
    PortfolioPortalSyncHistoryOrderType,
    PortfolioSentFaxSortOrderType,
    PortfolioSentFaxStatus,
    PrescriptionRenewalsOrderType,
    PrescriptionRenewalsViewRenewMedicationTableOrderType,
    PreventiveRecallTab,
    PrivateBill_BilledTo,
    RecallStatusTypes,
    RedirectTo,
    SchedulerDisplayMode,
    SchedulingTabViews,
    SitesUIState,
    SortDirection,
    TreeNodeTarget };
